import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { NavigationStart, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/_services';

@Component({
  selector: 'app-user-core-menu',
  templateUrl: './user-core-menu.component.html',
  styleUrls: ['./user-core-menu.component.scss']
})
export class UserCoreMenuComponent implements OnInit {

  route_active: string ;
  idvehicule:any =43
  linkActive: string;
  linkSelected: string;
  e:string;
  hideSpinner: boolean =false;
  title: any;
  urlSelectionner: string;
  constructor(private _snackBar: MatSnackBar,private spinnerMenu: NgxSpinnerService,private router: Router ,private authenticationService: AuthenticationService,private http: HttpClient) {

    this.linkSelected = this.router.url
    //console.log(this.linkSelected)

  }
  
  routerChangeMethod(url){
    this.title = url;
   // this.router.navigate([url]);
  }
  RedirectGo(e){
   
    this.hideSpinner = true
    this.spinnerMenu.show();
    //this.router.navigate([e]);
  //  window.location.href= e
    this.linkSelected = e
    this.spinnerMenu.hide();
 
    this.hideSpinner = false

  }
  ngOnInit(): void {
    this.router.events.subscribe(event =>{
      if (event instanceof NavigationStart){
        this.urlSelectionner = event.url.split('/')[4]
            //console.log(event.url.split('/')[2][1])
            this.routerChangeMethod(event.url);
            this.linkSelected = event.url
            //console.log(this.linkSelected)
            //this.RedirectGo(this.e);
        
            this.route_active =event.url
         //   window.location.href=event.url

        //    this.setrouter(event.url)
          //  this.RedirectGo(event.url)
          }
          })
   
    //console.log(localStorage.getItem("langue"))
    //console.log(localStorage.getItem("num1"))
  
   //  this.path =this.router.url
  }

  
  logout() {
    
    // this.http.post('http://192.168.1.98:8000/api/logout',{}).subscribe(data => {
    //   //console.log(data)
    // })
    this.authenticationService.logout();
    // this.router.navigate(['/login']);
}

horizontalPosition: MatSnackBarHorizontalPosition = 'end';
verticalPosition: MatSnackBarVerticalPosition = 'top';
openSnackBar(e) {
  this._snackBar.open(e, 'Fermer', {
    duration: 1000,
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
  });
}
}
